import Swiper from 'swiper/bundle';
import gsap from 'gsap';

import {isTouch} from '../helpers/detect-device';

export default () => {
	const sliderEl = document.querySelector('.simple-slider__block');

  if(sliderEl){
		const isTouchDevice = isTouch();
    let simpleSlider = document.querySelector('.simple-slider');
		let cursor = document.querySelector('#drag-cursor');

		const showCursor = sliderEl.getAttribute('data-show-cursor') === 'true';

		let cursorOptions = {
			touchMove: (swiper, e) => {
				if(isTouchDevice) return;
				moveCursor(cursor, e);
			},

			touchStart: (e) => {
				if(isTouchDevice) return;
				cursor.classList.add('drag-cursor--move');
			},

			touchEnd: (e) => {
				if(isTouchDevice) return;
				cursor.classList.remove('drag-cursor--move');
			}
		}
		if(!showCursor || isTouchDevice) cursorOptions = {};

    var swiperSimple = new Swiper(sliderEl, {
      slidesPerView: 'auto',
      freeMode: true,
      mousewheel: false,

      navigation: {
        nextEl: simpleSlider.querySelector('.simple-slider__button-next'),
        prevEl: simpleSlider.querySelector('.simple-slider__button-prev'),
      },
			on: cursorOptions
			
    });

		if(showCursor && !isTouchDevice) {
			sliderEl.addEventListener("pointerover", (e) => {
				cursor.classList.remove('drag-cursor--hidden');
				document.body.classList.add('body--cursor-hidden');
			});
	
			sliderEl.addEventListener("pointerout", (e) => {
				cursor.classList.add('drag-cursor--hidden');
				document.body.classList.remove('body--cursor-hidden');
			});
			document.addEventListener("mousemove", (e) => {
				moveCursor(cursor, e);
			});
	
		}

		function moveCursor(cursor, e){

      let cursorLeftPosition = e.clientX;
      let cursorTopPosition = e.clientY + scrollY;

      gsap.to(cursor, {
        x: cursorLeftPosition,
        y: cursorTopPosition, 
        ease: 'none', 
        duration: 0
      });
    }
  }
}